import React, { useEffect, useState } from "react";
import "./AgentLeads.css";
import { API } from "../../constants/Api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { Button, Flex, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";

function ListingLeads() {
  const token = localStorage.getItem("token");
  const [activeTab, setActiveTab] = useState("Buy Leads");
  const [selected, setSelected] = useState([]);
  const [grandTotal, setGrandTotal] = useState(0);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [records, setRecords] = useState([]);
  const [records1, setRecords1] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [newSelectedData, setNewSelectedData] = useState([]);
  const [openNewResponsive, setOpenNewResponsive] = useState(false);
  const [user, setUser] = useState([]);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const getTours = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${API}/MakeAnoffer/get-make-offers-agents`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();
        if (response.ok) {
          setData(json.data || []);
          setRecords(json.data || []);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        setLoading(false);
      }
    };
    getTours();
  }, [token]);

  useEffect(() => {
    const getPaidTours = async () => {
      try {
        const response = await fetch(
          `${API}/MakeAnoffer/getPaid-makeandoffers-tours`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();
        if (response.ok) {
          setData1(json.data || []);
          setRecords1(json.data || []);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };
    getPaidTours();
  }, [token]);
  const fetchUser = async (id) => {
    const response = await fetch(`${API}/users/single-user/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const json = await response.json();
    if (response.ok) {
      setUser(json.data);
      setOpenNewResponsive(true);
    }
  };
  const handleCheckClick = (id) => {
    setSelected((prevSelected) =>
      prevSelected.includes(id) ? prevSelected : [...prevSelected, id]
    );
  };

  const handleRemoveItem = (id) => {
    setSelected(selected.filter((item) => item !== id));
  };

  useEffect(() => {
    const handleSelectedData = () => {
      setSelectedData(data.filter((data) => selected.includes(data._id)));
      setGrandTotal(
        data
          .filter((data) => selected.includes(data._id))
          .reduce((sum, item) => sum + item.price, 0)
      );
    };
    handleSelectedData();
  }, [selected]);

  const ChatClick = () => {
    navigate("/agent-auth/listing-chat");
  };

  const [openResponsive, setOpenResponsive] = useState(false);

  const openTerms = () => {
    if (selectedData.length > 0) {
      setOpenResponsive(true);
    } else {
      toast.error("Please select leads first");
    }
  };

  // const handleBuy = () => {
  //   navigate("/checkout", {
  //     state: {
  //       data: selectedData,
  //       total: grandTotal,
  //       ids: selected,
  //       type: "listing",
  //     },
  //   });
  // };
  const handleBuy = () => {
    // Store data in localStorage
    localStorage.setItem(
      "checkoutData",
      JSON.stringify({
        data: selectedData,
        total: grandTotal,
        ids: selected,
        type: "listing",
      })
    );

    navigate("/checkout");
  };

  const openNewTerms2 = (id, user) => {
    const myData = data1.find((item) => item._id === id);
    if (myData) {
      console.log("aqdas yes 2");
      setNewSelectedData(myData);

      fetchUser(user);
    }
  };
  const columns = [
    {
      name: "Lead Name",
      selector: (row) => (
        <div className="table-layout-content-header-box">
          {selected.includes(row._id) ? (
            <img
              role="button"
              src="/img/checked.svg"
              className="img-fluid me-3"
              alt=""
              onClick={() => handleRemoveItem(row._id)}
            />
          ) : (
            <img
              role="button"
              src="/img/uncheck.svg"
              className="img-fluid opacity-50 me-3"
              alt=""
              onClick={() => handleCheckClick(row._id)}
            />
          )}
          <div className="table-layout-content-header-image">
            {row.houseImages.length > 0 ? (
              <img
                src={row.houseImages[0]}
                className="table-layout-content-header-image-media img-fluid"
                alt=""
              />
            ) : (
              <img
                src="/img/aqdas.jpeg"
                className="table-layout-content-header-image-media img-fluid"
                alt=""
              />
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.houseAddress}
            </h3>
            <p className="table-layout-content-header-details-zipcode my-0">
              {row.houseZipCode}
            </p>
          </div>
        </div>
      ),
      sortable: false,
      minWidth: "500px",
    },
    {
      name: "Date of Request",
      selector: (row) => row.tourDateTime || "No Date",
      cell: (row) =>
        row.tourDateTime
          ? format(new Date(row.tourDateTime), "dd MMM, yyyy")
          : "No Date",
      sortable: true,
      minWidth: "130px",
      center: true,
    },
    {
      name: "Price",
      selector: (row) => `$${row.price}`,
      sortable: true,
      right: true,
    },
  ];

  const column1 = [
    {
      name: "Tours",
      selector: (row) => row.houseAddress,
      cell: (row) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            <img
              src={
                row.houseImages.length > 0
                  ? row.houseImages[0]
                  : "/img/aqdas.jpeg"
              }
              className="table-layout-content-header-image-media img-fluid"
              alt=""
            />
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              {row.houseAddress}
            </h3>
            <p className="table-layout-content-header-details-zipcode my-0">
              {row.houseZipCode}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      minWidth: "400px",
    },
    {
      name: "Date of Tour",
      selector: (row) => row.tourDateTime || "No Date",
      cell: (row) =>
        row.tourDateTime
          ? format(new Date(row.tourDateTime), "dd MMM, yyyy")
          : "No Date",
      sortable: true,
      minWidth: "130px",
    },
    {
      name: "Status",
      selector: (row) => row.tourStatus,
      cell: (row) =>
        row.tourStatus === "pending" ? (
          <div className="tour-status-pending-1">{row.tourStatus}</div>
        ) : (
          <div className="tour-status-completed-1">{row.tourStatus}</div>
        ),
      sortable: true,
      minWidth: "150px",
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="tour-cta-1"
          onClick={() => openNewTerms2(row._id, row.user)}
        >
          Expand
        </button>
      ),
      minWidth: "200px",
    },
    {
      name: "Action",
      cell: (row) => (
        <button className="tour-cta-1" onClick={() => ChatClick()}>
          Chat
        </button>
      ),
      minWidth: "200px",
    },
  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };

  return (
    <div className="agent-lead">
      {loading ? (
        <div className="wait-loader">
          <div className="spinner-grow text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <h2 className="user-layout-page-heading">Leads</h2>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="">
                  <button
                    className={`btn agent-leads-tab ${
                      activeTab === "Buy Leads" ? "active-agent-leads-tab" : ""
                    }`}
                    onClick={() => setActiveTab("Buy Leads")}
                  >
                    Buy Leads
                  </button>
                  <button
                    className={`btn agent-leads-tab ms-3 ${
                      activeTab === "Manage Leads"
                        ? "active-agent-leads-tab"
                        : ""
                    }`}
                    onClick={() => setActiveTab("Manage Leads")}
                  >
                    Manage Leads
                  </button>
                </div>
              </div>
            </div>
          </div>
          {activeTab === "Buy Leads" ? (
            <div className="container-fluid agent-buy-leads-container">
              <Modal
                style={{ padding: "0px", margin: "0px" }}
                centered
                open={openResponsive}
                footer={null}
                closable={false}
                width={{
                  xs: "100%",
                  sm: "100%",
                  md: "90%",
                  lg: "90%",
                  xl: "80%",
                  xxl: "65%",
                }}
              >
                <div
                  className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
                >
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 text-white">
                        <h2 className="lead-pop-heading">You are buying:</h2>
                      </div>
                    </div>
                    <div className="row">
                      {selectedData.length > 0 ? (
                        <div className="col-12 px-0 pt-4">
                          <table className="table lead-table">
                            <tbody className="lead-table-body">
                              {selectedData.map((tour) => (
                                <tr
                                  key={tour._id}
                                  className="lead-table-body-row"
                                >
                                  <td className="lead-table-data-1">
                                    <div className="lead-table-layout-content-header-box">
                                      <div className="lead-table-layout-content-header-image">
                                        {tour.houseImages.length > 0 ? (
                                          <img
                                            src={tour.houseImages[0]}
                                            className="lead-table-layout-content-header-image-media img-fluid"
                                            alt=""
                                          />
                                        ) : (
                                          <>
                                            <img
                                              src="/img/aqdas.jpeg"
                                              className="lead-table-layout-content-header-image-media img-fluid"
                                              alt=""
                                            />
                                          </>
                                        )}
                                      </div>
                                      <div className="lead-table-layout-content-header-details">
                                        <h3 className="lead-table-layout-content-header-details-name my-0">
                                          {tour.houseAddress}
                                        </h3>
                                        <p className="lead-table-layout-content-header-details-zipcode my-0">
                                          {tour.houseZipCode}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="lead-table-data-last">
                                    <div className="tour-date w-100 pe-3 text-end">
                                      ${tour.price}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                          <img
                            src="/img/leadership-empty.svg"
                            className="img-fluid"
                            alt=""
                          />
                          <h2 className="leadership-empty-heading">
                            It’s Empty here!
                          </h2>
                          <p className="leadership-empty-para mt-2">
                            Look’s like you haven’t any data to display!
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="row">
                      <div className="col-12 devider-lead"></div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <h2 className="lead-grand-total">Grand Total</h2>
                      </div>
                      <div className="col-md-6 text-end">
                        <h2 className="lead-grand-total-price">
                          ${grandTotal}
                        </h2>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6 text-white">
                        <button
                          className="btn user-register-button"
                          onClick={handleBuy}
                        >
                          Buy Selected Leads
                        </button>
                      </div>
                      <div className="col-md-6 text-white">
                        <button
                          onClick={() => setOpenResponsive(false)}
                          className="btn schedule-tour-skip-button"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
              <div className="row">
                {data.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={columns}
                      data={records}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={loading}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t any data to display!
                    </p>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12 px-0 pt-4 d-flex justify-content-center">
                  <button className="btn buy-lead-button" onClick={openTerms}>
                    Buy Selected Leads
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="row">
                <Modal
                  centered
                  open={openNewResponsive}
                  footer={null}
                  closable={false}
                  width={{
                    xs: "100%",
                  sm: "100%",
                  md: "90%",
                  lg: "90%",
                  xl: "80%",
                  xxl: "65%",
                  }}
                >
                  <div
                    className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
                  >
                    <img
                      src="/img/pop-up-close.svg"
                      className="img-fluid pop-up-close"
                      onClick={() => setOpenNewResponsive(false)}
                      role="button"
                      alt=""
                    />
                    <div
                      className={`container-fluid ${isMobile ? "px-0" : ""}`}
                    >
                      <div className="row">
                        <div className="col-md-5 d-flex align-items-center">
                          <div className="row">
                            <div className="col-12">
                              {user ? (
                                <div className="lending-header-box">
                                  <div className="lending-header-image">
                                    {user.imageUrl ? (
                                      <img
                                        src={user.imageUrl}
                                        className="lending-image-media"
                                        alt=""
                                      />
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div className="lending-header-details">
                                    <h3
                                      className="lending-header-details-name my-0"
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {user.name}
                                    </h3>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-7">
                          <div className="container-fluid lo-approve-right-card">
                            <div className={`row ${isMobile ? "" : "h-100"}`}>
                              <div
                                className={`${newSelectedData.bankContractPdf ? "col-md-9" : "col-md-12"} d-flex flex-column justify-content-center h-100 gap-3`}
                              >
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Email
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    {user.email}
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Number
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    +1 {user.phonenumber}
                                  </div>
                                </div>
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Employement
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    {newSelectedData.employeementStatus}
                                  </div>
                                </div>
                                {/* <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Tour
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                    {newSelectedData?.yesOrNo
                                      ? newSelectedData.yesOrNo
                                          .charAt(0)
                                          .toUpperCase() +
                                        newSelectedData.yesOrNo
                                          .slice(1)
                                          .toLowerCase()
                                      : "N/A"}
                                  </div>
                                </div> */}
                                <div className="row">
                                  <div
                                    className={`col-md-5 ${isMobile ? "" : "pe-0"}`}
                                  >
                                    Down Payment
                                  </div>
                                  <div
                                    className={`col-md-7 ${isMobile ? "" : "p-0"}`}
                                  >
                                  {'$' + newSelectedData.downPayment?.toLocaleString()}
                                  </div>
                                </div>
                              </div>
                              {newSelectedData.bankContractPdf ? (
                                <>
                                  <div
                                    className={`col-md-3 d-flex ${isMobile ? "justify-content-center" : "justify-content-end"}`}
                                  >
                                    <div className="lo-apprive-pdf-card">
                                      <img
                                        src="/img/download-pdf.svg"
                                        className="img-fluid"
                                        alt=""
                                      />
                                      <a
                                        target="_blank"
                                        href={newSelectedData.bankContractPdf}
                                        download={
                                          newSelectedData.bankContractPdf
                                        }
                                        style={{
                                          color: "#ffffff",
                                          fontFamily: "Degular-Light",
                                          opacity: "0.7",
                                          textAlign: "center",
                                          textDecoration: "none",
                                        }}
                                      >
                                        Download Pre-Approval
                                      </a>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                {data1.length > 0 ? (
                  <div className="col-12 px-0 pt-4">
                    <DataTable
                      columns={column1}
                      data={records1}
                      pagination
                      paginationPerPage={15}
                      paginationRowsPerPageOptions={[10, 15, 20, 50]}
                      customStyles={customStyles}
                      progressPending={loading}
                      progressComponent={
                        <div className="text-center my-2 bg-white">
                          <div
                            className="spinner-border text-secondary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      }
                      className="table table-striped table-hover"
                    />
                  </div>
                ) : (
                  <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
                    <img
                      src="/img/leadership-empty.svg"
                      className="img-fluid"
                      alt=""
                    />
                    <h2 className="leadership-empty-heading">
                      It’s Empty here!
                    </h2>
                    <p className="leadership-empty-para mt-2">
                      Look’s like you haven’t any data to display!
                    </p>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default ListingLeads;
